import toast from "react-simple-toasts";

export const alertError = (response) => {
  toast(response, { className: "toast-error", time: 8000 });
};

export const alertSuccess = (response) => {
  const local = localStorage.getItem("i18nextLng");
  const message = local === "en" ? response.message : response.message_fr;
  toast(message, { className: "toast-success", time: 5000 });
};

export const alertSuccessSimple = (response) => {
  toast(response, { className: "toast-success", time: 5000 });
};